export enum FormChipsTypesEnum{
    INPUT = 'input',
    AUTOCOMPLETE = 'autocomplete',
}
